import React, { useState, useEffect, useRef } from 'react';
import TopTabs from "../TopTabs"
import { useParams } from 'react-router-dom';
import { expendituresProjectSearchAPI, invoiceProjectSearchAPI } from 'src/api/ReportsAPI';
import BackProjectButton from 'src/components/BackProjectButton';
import { shallowEqual, useSelector } from 'react-redux';
import config from "src/config";
import { toast } from 'react-toastify';
import { postRequest } from 'src/utils/RequestUtil';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormikTextarea from 'src/components/formik/FormikTextarea';
import FormikInput from 'src/components/formik/FormikInput';
import DatePicker from 'react-flatpickr';
import { costFormat, formatDate } from 'src/utils/CommonUtils';
import ProjectPermissionHOC from 'src/hoc/ProjectPermissionHOC';
import ViewHistory from 'src/containers/project-container/View/invoice/ViewHistory';
import DescriptionModal from './DescriptionModal';

const InvoiceContainer = () => {
    const offcanvasRef = useRef(null);
    const { projectId } = useParams();
    const [invoices, setInvoices] = useState([])
    const [invoiceId, setInvoiceId] = useState('')
    const [actualInvoices, setActualInvoices] = useState([])
    const { currentRecord } = useSelector((state) => state.ProjectReducer, shallowEqual)
    const [isEditMode, setIsEditMode] = useState(false);
    const projectCode = (currentRecord?.RefClientId?.ClientProjectCode) ? `${currentRecord?.RefClientId?.ClientProjectCode} ${currentRecord.ProjectSubCode}` : ''
const [showDescModal, setShowDescModal] = useState(false);
const [selectedDescription, setSelectedDescription] = useState("");

  useEffect(() => {
     const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
     const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));
     return () => {
       tooltipList.forEach(tooltip => tooltip.dispose());
     };
   }, [invoices]);

    const getProjectInvoices = async () => {
        try {
            const resp = await invoiceProjectSearchAPI({ projectId });
            setInvoices(resp?.data?.data)
        } catch (error) {
            console.error('error from profit and loss', error);
        }
    };

    useEffect(() => {
        getProjectInvoices();
    }, []);

    const defaultValues = {
        _id: null,
        invoiceNo: "",
        date: null,
        totalAmount: "",
        creditedAmount: "",
        description: "",
    }
    const [initialValues, setInitialValues] = useState(defaultValues);
    const validationSchema = Yup.object({
        invoiceNo: Yup.string().required("Invoice Number is required"),
        date: Yup.date().required("Date is required"),
        totalAmount: Yup.number().required("Total Amount is required").min(1, "Total Amount must be greater than 0"),
        // creditedAmount: Yup.number().min(1, "Credited Amount must be greater than 0"),
        creditedAmount: Yup.number()
            .nullable()
            .min(0, "Amount cannot be negative")
            .test(
                "creditedAmount-check",
                "Credited Amount cannot exceed Total Amount",
                function (value) {
                    const total = this.parent.totalAmount;
                    if (value == null || value === "") return true; // skip if empty
                    return Number(value) <= Number(total);
                }
            ),
    });

    const handleSubmit = async (values, { resetForm, setFieldValue }) => {
        // Log the form data after updating the values
        values.projectId = projectId
        const save_url = `${config.baseUrl}report/saveInvoice`;
        try {
            const result2 = await postRequest({
                url: save_url,
                data: values,
            });
            resetForm();
            setFieldValue("date", '');
            setInitialValues((prevState) => ({
                ...prevState,
                ...defaultValues,
            }));

            // Manually trigger the close by targeting the offcanvas button
            const closeButton = offcanvasRef.current.querySelector('.btn-close');
            if (closeButton) {
                closeButton.click(); // Trigger the close button's click event
            }

            toast.success(result2.data.message);
            getProjectInvoices();
        } catch (error) {
            // toast.error('Failed to submit form.');
            toast.error(error.response.data.message);
        }
    };

    const handleEdit = (data) => {
        setIsEditMode(true);
        setInitialValues((prevState) => ({
            ...prevState,
            _id: data?._id,
            date: data?.date,
            totalAmount: data?.totalAmount?.$numberDecimal,
            creditedAmount: data?.creditedAmount?.$numberDecimal,
            description: data?.description,
            invoiceNo: data?.invoiceNo,
        }));

    }
    const handleOpenModal = () => {
        setIsEditMode(false);
        setInitialValues((prevState) => ({
            ...prevState,
            ...defaultValues,
        }));
    };
    const handleActualHistory = (actualAmount) => {
        // console.log("actualExpenditures", actualAmount);
        setActualInvoices(actualAmount)
    }


    const actualOffRef = useRef(null);
    const defaultActualValues = {
        totalAmount: "",
        creditedAmount: "",
        description: "",
    }
    const [initialActualValues, setInitialActualValues] = useState(defaultActualValues);
    const validationActualSchema = Yup.object({
        totalAmount: Yup.number().min(1, "Total Amount must be greater than 0"),
        creditedAmount: Yup.number().min(1, "Credited Amount must be greater than 0"),
    });
    const handleActualSubmit = async (values, { resetForm, setFieldValue }) => {
        // Log the form data after updating the values
        values.projectId = projectId
        values.invoiceId = invoiceId
        const save_url = `${config.baseUrl}report/saveActualInvoice`;
        try {
            const result2 = await postRequest({
                url: save_url,
                data: values,
            });
            resetForm();
            setInitialActualValues((prevState) => ({
                ...prevState,
                ...defaultActualValues,
            }));

            // Manually trigger the close by targeting the offcanvas button
            const closeButton = actualOffRef.current.querySelector('.btn-close');
            if (closeButton) {
                closeButton.click(); // Trigger the close button's click event
            }

            toast.success(result2.data.message);
            getProjectInvoices();
        } catch (error) {
            toast.error('Failed to submit form.');
        }
    };
    const handleActualOpenModal = (expandedId) => {
        setInvoiceId(expandedId)
        setInitialActualValues((prevState) => ({
            ...prevState,
            ...defaultActualValues,
        }));
    };

    return (
        <>
            <div className="row">
                <div className="col-xxl-12 col-xl-12">
                    <div className="card h-100">
                        <div className="card-body p-24">

                            <BackProjectButton />

                            <ul className="d-flex align-items-center gap-2">
                                <li className="fw-medium">
                                    <a
                                        href="/"
                                        className="d-flex align-items-center gap-1 hover-text-primary"
                                    >
                                        <iconify-icon
                                            icon="solar:home-smile-angle-outline"
                                            className="icon text-lg"
                                        ></iconify-icon>
                                        Special Access
                                    </a>
                                </li>
                                <li>-</li>
                                <li className="fw-medium">P&amp;L </li>
                            </ul>
                            <TopTabs />
                            <div className="d-flex flex-wrap align-items-center gap-1 justify-content-between my-16">
                                <h6 className="text-lg fw-semibold mb-0 text-primary-900 d-flex align-items-center gap-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={16}
                                        height={16}
                                        fill="currentColor"
                                        className="bi bi-stack"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="m14.12 10.163 1.715.858c.22.11.22.424 0 .534L8.267 15.34a.6.6 0 0 1-.534 0L.165 11.555a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.6.6 0 0 1 .534 0l7.568 3.784a.3.3 0 0 1 0 .535L8.267 8.165a.6.6 0 0 1-.534 0L.165 4.382a.299.299 0 0 1 0-.535z" />
                                        <path d="m14.12 6.576 1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.6.6 0 0 1-.534 0L.165 7.968a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0z" />
                                    </svg>{" "}
                                    {projectCode}
                                </h6>
                                <div className='d-flex align-items-center gap-3'>
                                    <ProjectPermissionHOC scope="view_report.expenditure.add">
                                        <button type="button" className="btn btn-outline-primary-600 radius-8 px-20 py-9 d-flex align-items-center gap-2"
                                            data-bs-toggle="offcanvas" data-bs-target="#special-access-fil" aria-controls="special-access-fil"
                                            onClick={handleOpenModal}
                                        >
                                            + Add Invoice Details
                                        </button>
                                    </ProjectPermissionHOC>
                                </div>
                            </div>
                            <div className="table-responsive table-container" id="table-container">
                                {invoices.length === 0
                                    ? 'No Invoice'
                                    :
                                    <table className="table basic-border-table mb-0 table-hover">
                                        <thead>
                                            <tr className="dnd-moved">
                                                <th>S.No.</th>
                                                <th>Invoice No.</th>
                                                <th>Date</th>
                                                <th>Total Amount</th>
                                                <th>Credited Amount</th>
                                                <th>Pending Amount</th>
                                                <th>Created By</th>
                                                <th>Description</th>
                                                <th>Status</th>
                                                <th className='text-center'>Action</th>
                                            </tr>
                                        </thead>
                                        {/* <tbody id="table-body"> 
                                            {invoices.map((item, index) => {
                                                return (
                                                    <tr key={index} className="dnd-moved">                                                        
                                                        <td>{index + 1}</td>
                                                        <td>{item?.invoiceNo}</td>
                                                        <td>{formatDate(item?.date)}</td>
                                                        <td><div className='d-flex align-items-center justify-content-between gap-2'>
                                                            <span className='d-flex gap-1 text-nowrap'>
                                                                {costFormat(item?.totalAmount.$numberDecimal || 0)}
                                                            </span>
                                                        </div></td>
                                                        <td><div className='d-flex align-items-center justify-content-between gap-2'>
                                                            <span className='d-flex gap-1 text-nowrap'>
                                                                {costFormat(item?.creditedAmount.$numberDecimal || 0)}
                                                            </span>
                                                        </div></td>
                                                        <td>{item?.userId.firstName + " " + item?.userId.lastName || "N/A"}</td>
                                                        <td>{item?.description} </td>
                                                        <td className='text-center'>
                                                            <ProjectPermissionHOC scope="view_report.expenditure.add">
                                                                <button onClick={() => handleEdit(item)} data-bs-toggle="offcanvas" data-bs-target="#special-access-fil" aria-controls="special-access-fil"><i className='mdi mdi-pencil text-primary-700 mdi-24px'></i></button>
                                                            </ProjectPermissionHOC>
                                                        </td>
                                                    </tr>
                                                )
                                            })}

                                        </tbody> */}
                                        <tbody id="table-body">
                                            {invoices.map((item, index) => {

                                                const totalAmount = parseFloat(item?.totalAmount?.$numberDecimal || 0);
                                                const creditedAmount = parseFloat(item?.creditedAmount?.$numberDecimal || 0);
                                                const pendingAmount = totalAmount - creditedAmount;

                                                let status = "Pending";
                                                let statusClass = "text-white bg-danger-600 px-20 py-6 radius-4 w-100 text-center";

                                                if (creditedAmount === totalAmount) {
                                                    status = "Fully Paid";
                                                    statusClass = "text-white bg-success-600 px-20 py-6 radius-4 w-100 text-center";
                                                }
                                                else if (creditedAmount > 0 && creditedAmount < totalAmount) {
                                                    status = "Partially Paid";
                                                    statusClass = "text-white bg-warning-600 px-20 py-6 radius-4 w-100 text-center";
                                                }


                                                return (
                                                    <tr key={index} className="dnd-moved">
                                                        <td>{index + 1}</td>
                                                        <td>{item?.invoiceNo}</td>
                                                        <td>{formatDate(item?.date)}</td>

                                                        {/* Total Amount */}
                                                        <td>
                                                            <span className="text-nowrap">
                                                                {costFormat(totalAmount)}
                                                            </span>
                                                        </td>

                                                        {/* Credited Amount */}
                                                        <td>
                                                            <span className="text-nowrap">
                                                                {costFormat(creditedAmount)}
                                                            </span>
                                                        </td>

                                                        {/* Pending Amount - NEW */}
                                                        <td>
                                                            <span className="text-nowrap">
                                                                {costFormat(pendingAmount)}
                                                            </span>
                                                        </td>

                                                        {/* Created By */}
                                                        <td>{item?.userId?.firstName + " " + item?.userId?.lastName || "N/A"}</td>

                                                        {/* Description */}
                                                        {/* <td>{item?.description || "N/A"}</td> */}
                                                        <td>
                                                                {item?.description && item.description.length > 25 ? (
                                                                    <span className="d-flex align-items-center gap-2">
                                                                    {item.description.substring(0, 25)}...

                                                                    <button
                                                                        className="btn p-0 border-0 bg-transparent"
                                                                        onClick={() => {
                                                                        setSelectedDescription(item.description);
                                                                        setShowDescModal(true);
                                                                        }}
                                                                        data-bs-toggle="tooltip"
                             data-bs-placement="top"
                             data-bs-custom-class="tooltip-primary"
                                                                        data-bs-title="View Description"
                                                                    >
                                                                        <i className="mdi mdi-eye-outline text-primary-600 mdi-24px"></i>
                                                                    </button>
                                                                    </span>
                                                                ) : (
                                                                    item?.description || "N/A"
                                                                )}
                                                          </td>


                                                        {/* Status - NEW */}
                                                        <td>
                                                            <span className={`fw-bold ${statusClass}`}>
                                                                {status}
                                                            </span>
                                                        </td>

                                                        {/* Actions */}
                                                        <td className="text-center">
                                                            <ProjectPermissionHOC scope="view_report.expenditure.add">
                                                                <button
                                                                    onClick={() => handleEdit(item)}
                                                                    data-bs-toggle="offcanvas"
                                                                    data-bs-target="#special-access-fil"
                                                                    aria-controls="special-access-fil"
                                                                >
                                                                    <i className="mdi mdi-pencil text-primary-700 mdi-24px"></i>
                                                                </button>
                                                            </ProjectPermissionHOC>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>

                                        {/* <tfoot>
                                            <tr>
                                                <th className='text-end align-middle' colSpan={7}>Total</th>
                                                {/* <th className='text-center align-middle' colSpan={1}><div className='text-primary-700'>{costFormat(expenditures.reduce((sum, exp) => sum + (isNaN(parseFloat(exp?.planAmount?.$numberDecimal)) ? 0 : parseFloat(exp?.planAmount?.$numberDecimal)), 0))}<span className='d-block font-12 text-neutral-400'>Total Plan Amt</span></div></th>  
                                                <th className='text-center align-middle' colSpan={1}><div className='text-primary-700'>
                                                    Total Amount
                                                    <span className='d-block font-16 text-neutral-400'>{costFormat(invoices.reduce((sum, inv) => sum + (isNaN(parseFloat(inv?.totalAmount?.$numberDecimal)) ? 0 : parseFloat(inv?.totalAmount?.$numberDecimal)), 0))}</span>
                                                    </div>
                                                </th>
                                                <th className='text-center align-middle' colSpan={1}><div className='text-primary-700'>
                                                  Credited Amount
                                                    <span className='d-block font-16 text-neutral-400'>{costFormat(invoices.reduce((sum, inv) => sum + (isNaN(parseFloat(inv?.creditedAmount?.$numberDecimal)) ? 0 : parseFloat(inv?.creditedAmount?.$numberDecimal)), 0))}</span>
                                                    </div>
                                                </th>
                                                  {/* Pending Amount – NEW  
        <th className='text-center align-middle'>
            <div className='text-primary-700'>
                Pending Amount
                <span className='d-block font-16 text-neutral-400'>
                    {costFormat(
                        invoices.reduce((sum, inv) => {
                            const total = parseFloat(inv?.totalAmount?.$numberDecimal) || 0;
                            const credited = parseFloat(inv?.creditedAmount?.$numberDecimal) || 0;
                            return sum + (total - credited);
                        }, 0)
                    )}
                </span>
            </div>
        </th>
                                            </tr>
                                        </tfoot> */}

                                        <tfoot>
                                            <tr>
                                                <th colSpan={6}></th>
                                                <th className="p-0" colSpan={4} style={{ position: 'sticky', right: '0' }}>
                                                    <div className="d-flex justify-content-end gap-5 py-3 pe-3">

                                                        {/* Total Amount */}
                                                        <div className="text-end">
                                                            <div className="text-primary-700">Total Amount</div>
                                                            <span className="d-block font-16 text-neutral-900">
                                                                {costFormat(
                                                                    invoices.reduce((sum, inv) =>
                                                                        sum + (parseFloat(inv?.totalAmount?.$numberDecimal) || 0), 0
                                                                    )
                                                                )}
                                                            </span>
                                                        </div>

                                                        {/* Credited Amount */}
                                                        <div className="text-end">
                                                            <div className="text-primary-700">Credited Amount</div>
                                                            <span className="d-block font-16 text-neutral-900">
                                                                {costFormat(
                                                                    invoices.reduce((sum, inv) =>
                                                                        sum + (parseFloat(inv?.creditedAmount?.$numberDecimal) || 0), 0
                                                                    )
                                                                )}
                                                            </span>
                                                        </div>

                                                        {/* Pending Amount */}
                                                        <div className="text-end">
                                                            <div className="text-primary-700">Pending Amount</div>
                                                            <span className="d-block font-16 text-danger-600">
                                                                {costFormat(
                                                                    invoices.reduce((sum, inv) => {
                                                                        const total = parseFloat(inv?.totalAmount?.$numberDecimal) || 0;
                                                                        const credited = parseFloat(inv?.creditedAmount?.$numberDecimal) || 0;
                                                                        return sum + (total - credited);
                                                                    }, 0)
                                                                )}
                                                            </span>
                                                        </div>

                                                    </div>
                                                </th>
                                            </tr>
                                        </tfoot>


                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div >


            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, setFieldValue, errors, touched }) => {
                    return (
                        <Form>
                            <div
                                ref={offcanvasRef}
                                className="offcanvas offcanvas-end"
                                id="special-access-fil"
                                aria-labelledby="filterRightLayout"
                            >
                                <div className="offcanvas-header border-bottom">
                                    <h5 className="offcanvas-title" id="filterRightLayout">
                                        {initialValues?._id ? "Edit" : "Add"} Invoice
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close d-none"
                                        data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="offcanvas-body">
                                    <div className="assignPopoHeight">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="mb-20 fontset001">
                                                    <label for="invoiceNo" className="form-label fw-semibold text-primary-light text-sm mb-8"> Invoice Number <span className="text-danger-600">*</span></label>
                                                    <FormikInput
                                                        name="invoiceNo"
                                                        id="invoiceNo"
                                                        className="form-control"
                                                        placeholder="Enter Invoice Number"
                                                        defaultValue={""}
                                                        disabled={isEditMode}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-12">
                                                <div className="mb-20 fontset001">
                                                    <label for="date" className="form-label fw-semibold text-primary-light text-sm mb-8">Invoice Date <span className="text-danger-600">*</span></label>
                                                    <DatePicker
                                                        id="date"
                                                        name="date"
                                                        type="date"
                                                        placeholder="MM/DD/YYYY"
                                                        className="form-control radius-8 bg-base"
                                                        value={initialValues?.date}
                                                        options={{
                                                            dateFormat: "m/d/Y", // Flatpickr format for MM/DD/YYYY
                                                            timezone: "local"
                                                        }}
                                                        onChange={(date) => setFieldValue('date', date)}
                                                        selected={values.date ? new Date(values.date) : null} // Ensure a valid Date object
                                                        disabled={isEditMode}
                                                    />
                                                    {errors.date && touched.date && (
                                                        <div className="text-danger mt-1">{errors.date}</div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-sm-12">
                                                <div className="mb-20 fontset001">
                                                    <label for="totalAmount" className="form-label fw-semibold text-primary-light text-sm mb-8"> Total Amount <span className="text-danger-600">*</span></label>
                                                    <FormikInput
                                                        name="totalAmount"
                                                        id="totalAmount"
                                                        className="form-control"
                                                        placeholder="Enter Total Amount"
                                                        defaultValue={""}
                                                        type="number"
                                                        min="0"
                                                        disabled={isEditMode}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-12">
                                                <div className="mb-20 fontset001">
                                                    <label for="creditedAmount" className="form-label fw-semibold text-primary-light text-sm mb-8"> Credited Amount <span className="text-secondary-600">(Till Date)</span></label>
                                                    <FormikInput
                                                        name="creditedAmount"
                                                        id="creditedAmount"
                                                        className="form-control"
                                                        placeholder="Enter Credited Amount"
                                                        defaultValue={""}
                                                        type="number"
                                                        min="0"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-12">
                                                <div className="mb-20 fontset001">
                                                    <label for="description" className="form-label fw-semibold text-primary-light text-sm mb-8"> Description <span className="text-secondary-600">(Optional)</span></label>
                                                    <FormikTextarea
                                                        name="description"
                                                        id="description"
                                                        className="form-control"
                                                        placeholder="Enter Description"
                                                        defaultValue={""}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="offcanvas-footer px-16">
                                    <button
                                        type="submit"
                                        className="btn btn-primary radius-6 px-14 py-6 text-sm w-100 my-12"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )
                }}
            </Formik>

            <ViewHistory actualInvoices={actualInvoices} />


            <Formik
                enableReinitialize={true}
                initialValues={initialActualValues}
                validationSchema={validationActualSchema}
                onSubmit={handleActualSubmit}
            >
                {({ values, setFieldValue, errors, touched }) => {
                    return (
                        <Form>
                            <div
                                ref={actualOffRef}
                                className="offcanvas offcanvas-end"
                                id="add-actualModal"
                                aria-labelledby="filterRightLayout2"
                            >
                                <div className="offcanvas-header border-bottom">
                                    <h5 className="offcanvas-title" id="filterRightLayout2">
                                        Add Actual Amount
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close d-none"
                                        data-bs-dismiss="offcanvas"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="offcanvas-body">
                                    <div className="assignPopoHeight">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="mb-20 fontset001">
                                                    <label for="amount" className="form-label fw-semibold text-primary-light text-sm mb-8"> Amount <span className="text-danger-600">*</span></label>
                                                    <FormikInput
                                                        name="amount"
                                                        id="amountA"
                                                        className="form-control"
                                                        placeholder="Enter Amount"
                                                        defaultValue={""}
                                                        type="number"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-12">
                                                <div className="mb-20 fontset001">
                                                    <label for="descriptionA" className="form-label fw-semibold text-primary-light text-sm mb-8"> Description <span className="text-danger-600">*</span></label>
                                                    <FormikTextarea
                                                        name="description"
                                                        id="descriptionA"
                                                        className="form-control"
                                                        placeholder="Enter Description"
                                                        defaultValue={""}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="offcanvas-footer px-16">
                                    <button
                                        type="submit"
                                        className="btn btn-primary radius-6 px-14 py-6 text-sm w-100 my-12"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )
                }}
            </Formik>

            <DescriptionModal
  open={showDescModal}
  description={selectedDescription}
  onClose={() => setShowDescModal(false)}
/>

        </>
    )
}
export default InvoiceContainer